var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Contenedor',{attrs:{"datos":_vm.datos,"datosEnabled":_vm.datosEnabled,"widthCard":"200px"},on:{"openURL":_vm.openURL}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }